import { Frame1e7t2kcdb3wu7 as Frame } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Frame.commonHtml.mjs';
import { ensureOutermostElement1f4fzdv7yw0ql as ensureOutermostElement } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/NativeElement.mjs';
import {
  Align_Start_getInstance48vaevgl3nrq as Align_Start_getInstance,
  Align_Stretch_getInstance2huaa6rbagugp as Align_Stretch_getInstance,
  Companion_getInstance23x6zslwzj0st as Companion_getInstance,
  Align_Center_getInstance366ihr7rj12mu as Align_Center_getInstance,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/models/data.mjs';
import {
  align3syrmjzjb5jar as align,
  weight31wqab1913ly4 as weight,
  shownWhen3t7othivfr11 as shownWhen,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/modifiers.commonHtml.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { sizeConstraints19w9rda6g3rqz as sizeConstraints } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/modifiers.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { RowOrCol3a33s3yce2tuv as RowOrCol } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/LinearLayouts.commonHtml.mjs';
import {
  get_rem14pbkv8p42gid as get_rem,
  get_rem2p56fiaxda5jo as get_rem_0,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/models/data.commonHtml.mjs';
import { Checkbox2he0oy51inwu6 as Checkbox } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Checkbox.commonHtml.mjs';
import {
  get_centered31th09q7x90sf as get_centered,
  get_atBottom2b5zia3cn544c as get_atBottom,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/helpers.mjs';
import { TextViewe6rp77b08kos as TextView } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/TextView.commonHtml.mjs';
import { KMutableProperty025txtn5b59pq1 as KMutableProperty0 } from '../../../../../../kotlin-kotlin-stdlib/kotlin/reflect/KPropertyJs.mjs';
import {
  TextView$_get_content_$ref_4pzcwl5a4gnldk8ef9 as TextView$_get_content_$ref_4pzcwl,
  TextView$_set_content_$ref_pketfb11e282hr0m0jl as TextView$_set_content_$ref_pketfb,
  IconView$_get_description_$ref_x7iif61khv8gb32hpy6 as IconView$_get_description_$ref_x7iif6,
  IconView$_set_description_$ref_rpvc1e1z9j41dqp1rw7 as IconView$_set_description_$ref_rpvc1e,
} from '../../App.mjs';
import {
  getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef,
  constructCallableReference23y65rf941mch as constructCallableReference,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import {
  CompactSemantic_getInstance3lxnpjuev524m as CompactSemantic_getInstance,
  ForcePaddingSemantic_getInstance2xrz1oepj1itn as ForcePaddingSemantic_getInstance,
  ButtonSemantic_getInstance3q30xblp6a1af as ButtonSemantic_getInstance,
  FieldSemantic_getInstancer1p3l15xmphu as FieldSemantic_getInstance,
  SubtextSemantic_getInstance1duu1ll1kgx8d as SubtextSemantic_getInstance,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/models/Theme.mjs';
import { themed2vu67ornd4jps as themed } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/themeDerivations.mjs';
import { Button263cw152yl80e as Button } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Button.commonHtml.mjs';
import { IconView32wln42r1v8cb as IconView } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/IconView.commonHtml.mjs';
import { Select2osqjs95yxuh6 as Select } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Select.commonHtml.mjs';
import { Edges2jf5wl855ambv as Edges } from '../../../../../../kiteui-library/com/lightningkite/kiteui/models/Rect.mjs';
import {
  IconButtonSemantic_getInstanceyhbmf43a1vw3 as IconButtonSemantic_getInstance,
  TableRowSemantic_getInstance396gywh21vbqh as TableRowSemantic_getInstance,
} from '../../theme/semantics.mjs';
import { get_pageNavigatorp3to6r4j8ctv as get_pageNavigator } from '../../../../../../kiteui-library/com/lightningkite/kiteui/navigation/Navigator.mjs';
import { LabelGapSemantic_getInstance2wftjv243mafi as LabelGapSemantic_getInstance } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/l2/labels.mjs';
import { isBlank1dvkhjjvox3p0 as isBlank } from '../../../../../../kotlin-kotlin-stdlib/kotlin/text/Strings.mjs';
import { AppState_getInstance33x03n2an9aul as AppState_getInstance } from '../../../../../../kiteui-library/com/lightningkite/kiteui/reactive/AppState.js.mjs';
import { get_stringsy7vodl9dj0ya as get_strings } from '../../strings.mjs';
import { onClick3gjrd4jjo1cak as onClick } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Button.mjs';
import { orPromise1iucc2to2udt2 as orPromise } from '../../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/coroutinesInteropJs.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function get_standardPageWidth() {
  _init_properties_view_utilities_kt__sl3u1q();
  return standardPageWidth;
}
var standardPageWidth;
function get_standardDialogWidth() {
  _init_properties_view_utilities_kt__sl3u1q();
  return standardDialogWidth;
}
var standardDialogWidth;
function maxWidth(_this__u8e3s4) {
  _init_properties_view_utilities_kt__sl3u1q();
  var out;
  // Inline function 'com.lightningkite.kiteui.views.direct.frame' call
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element = new (Frame())(_this__u8e3s4.get_context_h02k06_k$());
  ensureOutermostElement(element);
  _this__u8e3s4.willAddChild_hz2iwc_k$(element);
  out = sizeConstraints(align(element, Align_Start_getInstance(), Align_Stretch_getInstance()), VOID, VOID, VOID, VOID, VOID, get_standardPageWidth());
  element.onStartup_vrxh3i_k$();
  _this__u8e3s4.addChild_2qpft2_k$(element);
  return out;
}
function labeledCheckbox(_this__u8e3s4, label, isChecked) {
  _init_properties_view_utilities_kt__sl3u1q();
  // Inline function 'com.lightningkite.kiteui.views.direct.row' call
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element = new (RowOrCol())(_this__u8e3s4.get_context_h02k06_k$());
  ensureOutermostElement(element);
  _this__u8e3s4.willAddChild_hz2iwc_k$(element);
  element.set_vertical_nuap32_k$(false);
  element.set_gap_jwjroq_k$(get_rem(0.5));
  // Inline function 'com.lightningkite.kiteui.views.direct.checkbox' call
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element_0 = new (Checkbox())(element.get_context_h02k06_k$());
  ensureOutermostElement(element_0);
  element.willAddChild_hz2iwc_k$(element_0);
  element_0.bind_gesskf_k$(element_0.checked_1, isChecked);
  element_0.onStartup_vrxh3i_k$();
  element.addChild_2qpft2_k$(element_0);
  // Inline function 'com.lightningkite.kiteui.views.expanding' call
  var this_0 = get_centered(element);
  // Inline function 'com.lightningkite.kiteui.views.direct.text' call
  var this_1 = weight(this_0, 1.0);
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element_1 = new (TextView())(this_1.get_context_h02k06_k$());
  ensureOutermostElement(element_1);
  this_1.willAddChild_hz2iwc_k$(element_1);
  var tmp = KMutableProperty0();
  var tmp_0 = TextView$_get_content_$ref_4pzcwl(element_1);
  var tmp_1 = getPropertyCallableRef('content', 0, tmp, tmp_0, TextView$_set_content_$ref_pketfb(element_1));
  element_1.invoke_bnq13k_k$(tmp_1, ($this$invoke) => label);
  element_1.onStartup_vrxh3i_k$();
  this_1.addChild_2qpft2_k$(element_1);
  element.onStartup_vrxh3i_k$();
  _this__u8e3s4.addChild_2qpft2_k$(element);
  return element;
}
function labeledCheckbox_0(_this__u8e3s4, label, isChecked) {
  _init_properties_view_utilities_kt__sl3u1q();
  // Inline function 'com.lightningkite.kiteui.views.direct.frame' call
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element = new (Frame())(_this__u8e3s4.get_context_h02k06_k$());
  ensureOutermostElement(element);
  _this__u8e3s4.willAddChild_hz2iwc_k$(element);
  // Inline function 'com.lightningkite.kiteui.views.compact' call
  var this_0 = get_atBottom(element);
  // Inline function 'com.lightningkite.kiteui.views.direct.padded' call
  var this_1 = themed(this_0, CompactSemantic_getInstance());
  // Inline function 'com.lightningkite.kiteui.views.direct.row' call
  var this_2 = themed(this_1, ForcePaddingSemantic_getInstance());
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element_0 = new (RowOrCol())(this_2.get_context_h02k06_k$());
  ensureOutermostElement(element_0);
  this_2.willAddChild_hz2iwc_k$(element_0);
  element_0.set_vertical_nuap32_k$(false);
  // Inline function 'com.lightningkite.kiteui.views.direct.checkbox' call
  var this_3 = get_centered(element_0);
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element_1 = new (Checkbox())(this_3.get_context_h02k06_k$());
  ensureOutermostElement(element_1);
  this_3.willAddChild_hz2iwc_k$(element_1);
  element_1.bind_gesskf_k$(element_1.checked_1, isChecked);
  element_1.onStartup_vrxh3i_k$();
  this_3.addChild_2qpft2_k$(element_1);
  // Inline function 'com.lightningkite.kiteui.views.expanding' call
  var this_4 = get_centered(element_0);
  // Inline function 'com.lightningkite.kiteui.views.direct.text' call
  var this_5 = weight(this_4, 1.0);
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element_2 = new (TextView())(this_5.get_context_h02k06_k$());
  ensureOutermostElement(element_2);
  this_5.willAddChild_hz2iwc_k$(element_2);
  var tmp = KMutableProperty0();
  var tmp_0 = TextView$_get_content_$ref_4pzcwl(element_2);
  var tmp_1 = getPropertyCallableRef('content', 0, tmp, tmp_0, TextView$_set_content_$ref_pketfb(element_2));
  element_2.invoke_bnq13k_k$(tmp_1, ($this$invoke) => label($this$invoke));
  element_2.onStartup_vrxh3i_k$();
  this_5.addChild_2qpft2_k$(element_2);
  element_0.onStartup_vrxh3i_k$();
  this_2.addChild_2qpft2_k$(element_0);
  element.onStartup_vrxh3i_k$();
  _this__u8e3s4.addChild_2qpft2_k$(element);
  return element;
}
function iconTextButton(_this__u8e3s4, label, icon, setup) {
  _init_properties_view_utilities_kt__sl3u1q();
  // Inline function 'com.lightningkite.kiteui.views.buttonTheme' call
  // Inline function 'com.lightningkite.kiteui.views.direct.button' call
  var this_0 = themed(_this__u8e3s4, ButtonSemantic_getInstance());
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element = new (Button())(this_0.get_context_h02k06_k$());
  ensureOutermostElement(element);
  this_0.willAddChild_hz2iwc_k$(element);
  // Inline function 'com.lightningkite.kiteui.views.direct.row' call
  var this_1 = themed(element, CompactSemantic_getInstance());
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element_0 = new (RowOrCol())(this_1.get_context_h02k06_k$());
  ensureOutermostElement(element_0);
  this_1.willAddChild_hz2iwc_k$(element_0);
  element_0.set_vertical_nuap32_k$(false);
  // Inline function 'com.lightningkite.kiteui.views.direct.icon' call
  var this_2 = get_centered(element_0);
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element_1 = new (IconView())(this_2.get_context_h02k06_k$());
  ensureOutermostElement(element_1);
  this_2.willAddChild_hz2iwc_k$(element_1);
  element_1.set_source_3o5lkf_k$(icon.resize_q1xpz0_k$(get_rem_0(1)));
  var tmp = KMutableProperty0();
  var tmp_0 = IconView$_get_description_$ref_x7iif6(element_1);
  var tmp_1 = getPropertyCallableRef('description', 0, tmp, tmp_0, IconView$_set_description_$ref_rpvc1e(element_1));
  element_1.invoke_bnq13k_k$(tmp_1, ($this$invoke) => label($this$invoke));
  element_1.onStartup_vrxh3i_k$();
  this_2.addChild_2qpft2_k$(element_1);
  // Inline function 'com.lightningkite.kiteui.views.direct.text' call
  var this_3 = get_centered(element_0);
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element_2 = new (TextView())(this_3.get_context_h02k06_k$());
  ensureOutermostElement(element_2);
  this_3.willAddChild_hz2iwc_k$(element_2);
  var tmp_2 = KMutableProperty0();
  var tmp_3 = TextView$_get_content_$ref_4pzcwl(element_2);
  var tmp_4 = getPropertyCallableRef('content', 0, tmp_2, tmp_3, TextView$_set_content_$ref_pketfb(element_2));
  element_2.invoke_bnq13k_k$(tmp_4, ($this$invoke) => label($this$invoke));
  element_2.onStartup_vrxh3i_k$();
  this_3.addChild_2qpft2_k$(element_2);
  element_0.onStartup_vrxh3i_k$();
  this_1.addChild_2qpft2_k$(element_0);
  setup(element);
  element.onStartup_vrxh3i_k$();
  this_0.addChild_2qpft2_k$(element);
  return element;
}
function sortSelect(_this__u8e3s4, setup) {
  _init_properties_view_utilities_kt__sl3u1q();
  // Inline function 'com.lightningkite.kiteui.views.fieldTheme' call
  var this_0 = themed(_this__u8e3s4, CompactSemantic_getInstance());
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  var this_1 = themed(this_0, FieldSemantic_getInstance());
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element = new (RowOrCol())(this_1.get_context_h02k06_k$());
  ensureOutermostElement(element);
  this_1.willAddChild_hz2iwc_k$(element);
  element.set_vertical_nuap32_k$(true);
  // Inline function 'com.lightningkite.kiteui.views.direct.row' call
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element_0 = new (RowOrCol())(element.get_context_h02k06_k$());
  ensureOutermostElement(element_0);
  element.willAddChild_hz2iwc_k$(element_0);
  element_0.set_vertical_nuap32_k$(false);
  // Inline function 'com.lightningkite.kiteui.views.direct.icon' call
  var this_2 = get_centered(element_0);
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element_1 = new (IconView())(this_2.get_context_h02k06_k$());
  ensureOutermostElement(element_1);
  this_2.willAddChild_hz2iwc_k$(element_1);
  element_1.set_source_3o5lkf_k$(Companion_getInstance().sort_1.resize_q1xpz0_k$(get_rem_0(1)));
  var tmp = KMutableProperty0();
  var tmp_0 = IconView$_get_description_$ref_x7iif6(element_1);
  var tmp_1 = getPropertyCallableRef('description', 0, tmp, tmp_0, IconView$_set_description_$ref_rpvc1e(element_1));
  element_1.invoke_bnq13k_k$(tmp_1, sortSelect$lambda);
  element_1.onStartup_vrxh3i_k$();
  this_2.addChild_2qpft2_k$(element_1);
  // Inline function 'com.lightningkite.kiteui.views.direct.select' call
  var this_3 = get_centered(element_0);
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element_2 = new (Select())(this_3.get_context_h02k06_k$());
  ensureOutermostElement(element_2);
  this_3.willAddChild_hz2iwc_k$(element_2);
  var tmp0_right = get_rem(1.6);
  var tmp1_left = get_rem_0(0);
  var tmp2_top = get_rem_0(0);
  var tmp3_bottom = get_rem_0(0);
  element_2.set_paddingByEdge_53g79y_k$(Edges().new_com_lightningkite_kiteui_models_Edges_xdg8au_k$(tmp1_left, tmp2_top, tmp0_right, tmp3_bottom));
  setup(element_2);
  element_2.onStartup_vrxh3i_k$();
  this_3.addChild_2qpft2_k$(element_2);
  element_0.onStartup_vrxh3i_k$();
  element.addChild_2qpft2_k$(element_0);
  element.onStartup_vrxh3i_k$();
  this_1.addChild_2qpft2_k$(element);
  return element;
}
function exportButton(_this__u8e3s4, setup) {
  _init_properties_view_utilities_kt__sl3u1q();
  var tmp = Companion_getInstance().download_1;
  var tmp_0 = exportButton$lambda;
  return iconButton(_this__u8e3s4, tmp, tmp_0, ($this$iconButton) => {
    setup($this$iconButton);
    return Unit_instance;
  });
}
function addButton(_this__u8e3s4, label, setup) {
  _init_properties_view_utilities_kt__sl3u1q();
  return iconTextButton(_this__u8e3s4, label, Companion_getInstance().add_1, setup);
}
function iconButton(_this__u8e3s4, icon, description, setup) {
  _init_properties_view_utilities_kt__sl3u1q();
  // Inline function 'com.lightningkite.kiteui.views.direct.button' call
  var this_0 = themed(sizeConstraints(_this__u8e3s4, VOID, VOID, VOID, VOID, 1.0), IconButtonSemantic_getInstance());
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element = new (Button())(this_0.get_context_h02k06_k$());
  ensureOutermostElement(element);
  this_0.willAddChild_hz2iwc_k$(element);
  // Inline function 'com.lightningkite.kiteui.views.direct.icon' call
  var this_1 = get_centered(element);
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element_0 = new (IconView())(this_1.get_context_h02k06_k$());
  ensureOutermostElement(element_0);
  this_1.willAddChild_hz2iwc_k$(element_0);
  element_0.set_source_3o5lkf_k$(icon.resize_q1xpz0_k$(get_rem(1.25)));
  var tmp = KMutableProperty0();
  var tmp_0 = IconView$_get_description_$ref_x7iif6(element_0);
  var tmp_1 = getPropertyCallableRef('description', 0, tmp, tmp_0, IconView$_set_description_$ref_rpvc1e(element_0));
  element_0.invoke_bnq13k_k$(tmp_1, ($this$invoke) => description($this$invoke));
  element_0.onStartup_vrxh3i_k$();
  this_1.addChild_2qpft2_k$(element_0);
  setup(element);
  element.onStartup_vrxh3i_k$();
  this_0.addChild_2qpft2_k$(element);
  return element;
}
function goBackButton(_this__u8e3s4) {
  _init_properties_view_utilities_kt__sl3u1q();
  var tmp = shownWhen(_this__u8e3s4, VOID, VOID, ($this$shownWhen) => $this$shownWhen.invoke_r7m7el_k$(get_pageNavigator(_this__u8e3s4.get_context_h02k06_k$()).canGoBack_1));
  var tmp_0 = Companion_getInstance().arrowBack_1;
  var tmp_1 = goBackButton$lambda;
  return iconButton(tmp, tmp_0, tmp_1, goBackButton$lambda_0);
}
function keyValue(_this__u8e3s4, key, value) {
  _init_properties_view_utilities_kt__sl3u1q();
  // Inline function 'org.thecommunitygroupinc.cares.views.components.inlineLabel' call
  var label = key;
  // Inline function 'com.lightningkite.kiteui.views.direct.row' call
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element = new (RowOrCol())(_this__u8e3s4.get_context_h02k06_k$());
  ensureOutermostElement(element);
  _this__u8e3s4.willAddChild_hz2iwc_k$(element);
  element.set_vertical_nuap32_k$(false);
  // Inline function 'com.lightningkite.kiteui.views.direct.subtext' call
  // Inline function 'com.lightningkite.kiteui.views.direct.text' call
  var this_0 = sizeConstraints(get_centered(element), VOID, VOID, VOID, VOID, VOID, get_rem_0(10));
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element_0 = new (TextView())(this_0.get_context_h02k06_k$());
  ensureOutermostElement(element_0);
  this_0.willAddChild_hz2iwc_k$(element_0);
  element_0.set_themeChoice_py59um_k$(element_0.get_themeChoice_22tyn3_k$().plus_duvq05_k$(SubtextSemantic_getInstance()));
  var tmp = KMutableProperty0();
  var tmp_0 = TextView$_get_content_$ref_4pzcwl(element_0);
  var tmp_1 = getPropertyCallableRef('content', 0, tmp, tmp_0, TextView$_set_content_$ref_pketfb(element_0));
  element_0.invoke_bnq13k_k$(tmp_1, ($this$invoke) => label($this$invoke));
  element_0.onStartup_vrxh3i_k$();
  this_0.addChild_2qpft2_k$(element_0);
  // Inline function 'com.lightningkite.kiteui.views.expanding' call
  var this_1 = get_centered(element);
  // Inline function 'com.lightningkite.kiteui.views.direct.text' call
  var this_2 = weight(this_1, 1.0);
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element_1 = new (TextView())(this_2.get_context_h02k06_k$());
  ensureOutermostElement(element_1);
  this_2.willAddChild_hz2iwc_k$(element_1);
  var tmp_2 = KMutableProperty0();
  var tmp_3 = TextView$_get_content_$ref_4pzcwl(element_1);
  element_1.invoke_bnq13k_k$(getPropertyCallableRef('content', 0, tmp_2, tmp_3, TextView$_set_content_$ref_pketfb(element_1)), value);
  element_1.onStartup_vrxh3i_k$();
  this_2.addChild_2qpft2_k$(element_1);
  element.onStartup_vrxh3i_k$();
  _this__u8e3s4.addChild_2qpft2_k$(element);
  return element;
}
function reactiveLabel(_this__u8e3s4, label, value) {
  _init_properties_view_utilities_kt__sl3u1q();
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  var this_0 = themed(_this__u8e3s4, LabelGapSemantic_getInstance());
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element = new (RowOrCol())(this_0.get_context_h02k06_k$());
  ensureOutermostElement(element);
  this_0.willAddChild_hz2iwc_k$(element);
  element.set_vertical_nuap32_k$(true);
  // Inline function 'com.lightningkite.kiteui.views.direct.subtext' call
  // Inline function 'com.lightningkite.kiteui.views.direct.text' call
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element_0 = new (TextView())(element.get_context_h02k06_k$());
  ensureOutermostElement(element_0);
  element.willAddChild_hz2iwc_k$(element_0);
  element_0.set_themeChoice_py59um_k$(element_0.get_themeChoice_22tyn3_k$().plus_duvq05_k$(SubtextSemantic_getInstance()));
  var tmp = KMutableProperty0();
  var tmp_0 = TextView$_get_content_$ref_4pzcwl(element_0);
  var tmp_1 = getPropertyCallableRef('content', 0, tmp, tmp_0, TextView$_set_content_$ref_pketfb(element_0));
  element_0.invoke_bnq13k_k$(tmp_1, ($this$invoke) => {
    // Inline function 'com.lightningkite.reactive.context.TypedReactiveContext.invoke' call
    return label($this$invoke);
  });
  element_0.onStartup_vrxh3i_k$();
  element.addChild_2qpft2_k$(element_0);
  // Inline function 'com.lightningkite.kiteui.views.direct.text' call
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element_1 = new (TextView())(element.get_context_h02k06_k$());
  ensureOutermostElement(element_1);
  element.willAddChild_hz2iwc_k$(element_1);
  var tmp_2 = KMutableProperty0();
  var tmp_3 = TextView$_get_content_$ref_4pzcwl(element_1);
  var tmp_4 = getPropertyCallableRef('content', 0, tmp_2, tmp_3, TextView$_set_content_$ref_pketfb(element_1));
  element_1.invoke_bnq13k_k$(tmp_4, ($this$invoke) => {
    // Inline function 'com.lightningkite.reactive.context.TypedReactiveContext.invoke' call
    return value($this$invoke);
  });
  element_1.onStartup_vrxh3i_k$();
  element.addChild_2qpft2_k$(element_1);
  element.onStartup_vrxh3i_k$();
  this_0.addChild_2qpft2_k$(element);
  return element;
}
function maybeLabel(_this__u8e3s4, label, value) {
  _init_properties_view_utilities_kt__sl3u1q();
  return reactiveLabel(shownWhen(_this__u8e3s4, VOID, VOID, ($this$shownWhen) => {
    // Inline function 'com.lightningkite.reactive.context.TypedReactiveContext.invoke' call
    // Inline function 'kotlin.text.isNotBlank' call
    var this_0 = value($this$shownWhen);
    return !isBlank(this_0);
  }), label, value);
}
function emptyRow(_this__u8e3s4) {
  _init_properties_view_utilities_kt__sl3u1q();
  // Inline function 'com.lightningkite.kiteui.views.direct.padded' call
  var this_0 = themed(_this__u8e3s4, TableRowSemantic_getInstance());
  // Inline function 'com.lightningkite.kiteui.views.direct.text' call
  var this_1 = themed(this_0, ForcePaddingSemantic_getInstance());
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element = new (TextView())(this_1.get_context_h02k06_k$());
  ensureOutermostElement(element);
  this_1.willAddChild_hz2iwc_k$(element);
  var tmp = KMutableProperty0();
  var tmp_0 = TextView$_get_content_$ref_4pzcwl(element);
  var tmp_1 = getPropertyCallableRef('content', 0, tmp, tmp_0, TextView$_set_content_$ref_pketfb(element));
  element.invoke_bnq13k_k$(tmp_1, emptyRow$lambda);
  element.set_align_ypalx0_k$(Align_Center_getInstance());
  element.onStartup_vrxh3i_k$();
  this_1.addChild_2qpft2_k$(element);
  return element;
}
function sortSelect$lambda($this$invoke) {
  _init_properties_view_utilities_kt__sl3u1q();
  return 'Sort';
}
function exportButton$lambda($this$iconButton) {
  _init_properties_view_utilities_kt__sl3u1q();
  return $this$iconButton.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_exportCsvButton_84ycf9_k$();
}
function goBackButton$lambda($this$iconButton) {
  _init_properties_view_utilities_kt__sl3u1q();
  return $this$iconButton.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_goBackDescription_2wlgbo_k$();
}
function goBackButton$lambda_0($this$iconButton) {
  _init_properties_view_utilities_kt__sl3u1q();
  onClick($this$iconButton, VOID, VOID, VOID, goBackButton$lambda$slambda($this$iconButton));
  return Unit_instance;
}
function goBackButton$lambda$slambda($this_iconButton) {
  return constructCallableReference(($completion) => orPromise($completion, function *($completion) {
    get_pageNavigator($this_iconButton.get_context_h02k06_k$()).goBack_kj7lzl_k$();
    return Unit_instance;
  }), 0);
}
function emptyRow$lambda($this$invoke) {
  _init_properties_view_utilities_kt__sl3u1q();
  return $this$invoke.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_emptyRowText_pvodpf_k$();
}
var properties_initialized_view_utilities_kt_3q1a4k;
function _init_properties_view_utilities_kt__sl3u1q() {
  if (!properties_initialized_view_utilities_kt_3q1a4k) {
    properties_initialized_view_utilities_kt_3q1a4k = true;
    standardPageWidth = get_rem_0(72);
    standardDialogWidth = get_rem_0(40);
  }
}
//region block: exports
export {
  addButton as addButton16duilic9iyqp,
  emptyRow as emptyRow1djlr0t4x675n,
  exportButton as exportButton1ekt3fxzrhh34,
  goBackButton as goBackButton1g9k0xsmfm57i,
  iconButton as iconButton2nzpucy7a6ixd,
  iconTextButton as iconTextButton3p26faj7s7pcp,
  keyValue as keyValue1ck7xpd7fxylw,
  labeledCheckbox_0 as labeledCheckbox2i8m4uxe4r9p8,
  labeledCheckbox as labeledCheckbox1ycivizfzdk0y,
  maxWidth as maxWidth22r11xnm7d4h4,
  maybeLabel as maybeLabel2ow5e5yzodgn0,
  reactiveLabel as reactiveLabel206b3aonybuoa,
  sortSelect as sortSelect2bs9xha2fqnl1,
  get_standardDialogWidth as get_standardDialogWidth1plathvfuoe55,
};
//endregion

//# sourceMappingURL=view-utilities.mjs.map
